import { createContext } from 'react';
import { FeatureFlagsModules } from 'src/featureFlags/FeatureFlags.models';

type FeatureFlagContextProps = Record<FeatureFlagsModules, Record<string, boolean>>;

export const FeatureFlagContext = createContext<FeatureFlagContextProps>(
  {} as FeatureFlagContextProps,
);
